module.exports = __webpack_public_path__ + "static/media/contact-bg.a899cacd.jpg";